<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <h2 class="hakotan_title">特定商取引法に基づく表示</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="tokutei">
          <section>
            <div class="corp_table" ref="corp_yasumoku">
              <ul class="ul_corp_outline">
                <li>
                  <div>販売業者</div>
                  <div>株式会社ヤスモク</div>
                </li>
                <li>
                  <div>責任者</div>
                  <div>安田知弘</div>
                </li>
                <li>
                  <div>住所</div>
                  <div>〒501-4202 岐阜県郡上市八幡町市島18-1</div>
                </li>
                <li>
                  <div>電話番号</div>
                  <div>0575-62-2311</div>
                </li>
                <li>
                  <div>メールアドレス</div>
                  <div>info@yasumoku.jp</div>
                </li>
                <li>
                  <div>ホームページ</div>
                  <div><a href="https://yasumoku.jp" target="_blank" rel="noopener noreferrer">https://yasumoku.jp</a></div>
                </li>
                <li>
                  <div>商品の販売価格</div>
                  <div>各商品ページをご参照ください。</div>
                </li>
                <li>
                  <div>商品以外の必要料金</div>
                  <div>
                    ・配送料<br>
                    ・組立設置等のサービス料（ご選択された場合）
                  </div>
                </li>
                <li>
                  <div>支払方法</div>
                  <div>
                    クレジットカード、金融機関でのお支払い
                  </div>
                </li>
                <li>
                  <div>支払時期</div>
                  <div>
                    【 クレジットカード決済 】<br>
                    ご注文時に決済となります。<br>
                  </div>
                  <div>
                    【 金融機関でのお支払い 】<br>
                    ご注文より7日以内にお振込みをお願いいたします。<br>
                  </div>
                </li>
                <li>
                  <div>商品の引渡時期</div>
                  <div>
                    商品によって納品可能日が異なります。詳しくは各商品ページをご覧ください
                  </div>
                </li>
                <li>
                  <div>返品・交換</div>
                  <div>
                    オーダー家具のため、注文後のキャンセルはできません。<br>
                    ただし、以下の場合は納品後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行います。<br>
                    ・商品に瑕疵がある場合<br>
                    ・商品説明と実際の商品が明らかに異なる場合<br>
                    ・梱包の不備により配送時に商品が破損した場合<br>
                    ・その他の商品の不具合
                  </div>
                </li>
              </ul>
            </div>
            <div id="border_line">
            </div>
            <div class="corp_table" ref="corp_candeal">
              <ul class="ul_corp_outline">
                <li>
                  <div>販売業者</div>
                  <div>株式会社キャンディルテクト</div>
                </li>
                <li>
                  <div>責任者</div>
                  <div>三浦 翔</div>
                </li>
                <li>
                  <div>住所</div>
                  <div>東京都江東区常盤1-2-5</div>
                </li>
                <li>
                  <div>電話番号</div>
                  <div>03-5625-4587</div>
                </li>
                <li>
                  <div>メールアドレス</div>
                  <div>te_hp@candeal.co.jp</div>
                </li>
                <li>
                  <div>ホームページ</div>
                  <div><a href="https://candeal-tect.co.jp" target="_blank" rel="noopener noreferrer">https://candeal-tect.co.jp</a></div>
                </li>
                <li>
                  <div>サービスの販売価格</div>
                  <div>各商品ページをご参照ください。</div>
                </li>
                <li>
                  <div>サービス以外の必要料金</div>
                  <div>
                    組立設置オプションには以下の費用が発生します。<br>
                    ・組立技術料：組立作業費および副資材、簡易養生材など。<br>
                    ・諸経費：交通費、燃料代など。
                  </div>
                </li>
                <li>
                  <div>支払方法</div>
                  <div>
                    ・クレジットカード決済、金融機関でのお支払い<br>
                  </div>
                </li>
                <li>
                  <div>支払時期</div>
                  <div>
                    【 クレジットカード決済 】<br>
                    ご注文時に決済となります。
                  </div>
                  <div>
                    【 金融機関でのお支払い 】<br>
                    ご注文より7日以内にお振込みをお願いいたします。<br>
                  </div>
                </li>
                <li>
                  <div>サービスの開始・完成時期</div>
                  <div>
                    工事の開始時期及び完成時期は、別途お客様と合意した時期といたします。<br>
                    ※地域（離島、遠隔地等）または時期（年末年始・夏季休業等）によっては通常より日数をいただく場合がございます。
                  </div>
                </li>
                <li>
                  <div>ご注文のキャンセル</div>
                  <div>
                    組立設置サービス契約の締結後は当該契約の解除（キャンセル）及び代金の返金はできません。<br>
                    詳細は利用規約第１１条をご覧ください。
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcTokukei',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'toukei', key: 'dcTokutei', title: '特定商取引法の表示', route: 'DcTokutei'}
      ]
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    scrollToAnchorPoint: function (refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({behavior: 'smooth'})
    }
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcTokutei.vue